import translations from './silicon.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/silicon'

export const silicon: Metal = {
  id: 38,
  slug: 'silicon',
  name: t.name,
  symbol: 'Si',
  // The sheet's pins are silicon-metal processing facilities, not quartz mines —
  // silicon metal is produced by reducing high-purity quartz in electric arc furnaces.
  mines: [
    {
      name: 'Leshan (China, silicon processing)',
      region: 'Leshan',
      coordinates: [103.77, 29.55],
    },
    {
      name: 'Shihezi (China, silicon processing)',
      region: 'Shihezi',
      coordinates: [86.04, 44.31],
    },
    {
      name: 'Burghausen (Germany, silicon processing)',
      region: 'Burghausen',
      coordinates: [12.83, 48.17],
    },
    {
      name: 'Alloy, Fayette County (USA, silicon processing)',
      region: 'Alloy',
      coordinates: [-81.1, 38.0],
    },
    {
      name: 'Xuzhou (China, silicon processing)',
      region: 'Xuzhou',
      coordinates: [117.28, 34.21],
    },
  ],
  countries: [
    { name: 'China', percent: 84.8 },
    { name: 'Brazil', percent: 4.1 },
    { name: 'Norway', percent: 2.6 },
    { name: 'France', percent: 2 },
    { name: 'Germany', percent: 1.3 },
    { name: 'Russia', percent: 1.1 },
  ],
  content: {
    smartphone: {
      quantityScore: 5,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'electronics', 'camera'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 3, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
    },
  },
}
